import * as tslib_1 from "tslib";
import { EventEmitter, OnChanges, OnInit, SimpleChanges } from '@angular/core';
import { AviationEvent, AviationEventTypeDesc, AviationEventType } from '../../shared/models/aviation-event.model';
import * as moment from 'moment-timezone';
import { MatDialog, MatDialogConfig, MatSnackBar } from '@angular/material';
import { EditToggleService } from '../../shared/services/edit-toggle.service';
import { EditEventLocationComponent } from '../edit-event-location/edit-event-location.component';
import { AviationEventsService } from '../../shared/services/aviation-events.service';
var EventDetailsComponent = /** @class */ (function () {
    function EventDetailsComponent(_editDescDialog, _toggleService, snackBar, _aviationEventsService) {
        this._editDescDialog = _editDescDialog;
        this._toggleService = _toggleService;
        this.snackBar = snackBar;
        this._aviationEventsService = _aviationEventsService;
        this.dataChangedEvent = new EventEmitter();
        this.editModeSet = false;
        this.aviationEventTypeDesc = AviationEventTypeDesc;
        this.aviationEventType = AviationEventType;
    }
    Object.defineProperty(EventDetailsComponent.prototype, "contactWebAddress", {
        get: function () {
            if (this.aviationEvent.webinarRegistrationLink.indexOf('http://') >= 0 ||
                this.aviationEvent.webinarRegistrationLink.indexOf('https://') >= 0) {
                return this.aviationEvent.webinarRegistrationLink;
            }
            else {
                return 'http://' + this.aviationEvent.webinarRegistrationLink;
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(EventDetailsComponent.prototype, "informationWebAddress", {
        get: function () {
            if (this.aviationEvent.informationWebsite.indexOf('http://') >= 0 ||
                this.aviationEvent.informationWebsite.indexOf('https://') >= 0) {
                return this.aviationEvent.informationWebsite;
            }
            else {
                return 'http://' + this.aviationEvent.informationWebsite;
            }
        },
        enumerable: true,
        configurable: true
    });
    EventDetailsComponent.prototype.ngOnInit = function () {
        var _this = this;
        this._toggleService.toggleEmitter.subscribe(function (isOn) {
            _this.editModeSet = isOn;
        });
        this.setDates();
    };
    EventDetailsComponent.prototype.ngOnChanges = function (changes) {
        this.setDates();
    };
    EventDetailsComponent.prototype.setDates = function () {
        this.eventStart = moment.tz(this.aviationEvent.startDateTime, 'UTC');
        this.eventStartDateString = this.eventStart.clone().tz(this.aviationEvent.timezone).format('dddd, MMMM Do, YYYY');
        this.eventStartTimeString = this.eventStart.clone().tz(this.aviationEvent.timezone).format('h:mm a z');
        this.eventEnd = moment.tz(this.aviationEvent.endDateTime, 'UTC');
        this.eventEndDateString = this.eventEnd.clone().tz(this.aviationEvent.timezone).format('dddd, MMMM Do, YYYY');
        this.eventEndTimeString = this.eventEnd.clone().tz(this.aviationEvent.timezone).format('h:mm a z');
    };
    EventDetailsComponent.prototype.reloadEntity = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var _a;
            return tslib_1.__generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        _a = this;
                        return [4 /*yield*/, this._aviationEventsService.getAviationEventById(this.aviationEvent.eventId)];
                    case 1:
                        _a.aviationEvent = _b.sent();
                        this.setDates();
                        this.dataChangedEvent.emit(this.aviationEvent);
                        return [2 /*return*/];
                }
            });
        });
    };
    EventDetailsComponent.prototype.openEditDetailsDialog = function () {
        var dialogConfig = new MatDialogConfig();
        dialogConfig.disableClose = false;
        dialogConfig.autoFocus = true;
        dialogConfig.width = '800px';
        dialogConfig.data = { aviationEvent: this.aviationEvent };
        var DIALOG_REF = this._editDescDialog.open(EditEventLocationComponent, dialogConfig);
        this._handleModalClose(DIALOG_REF);
    };
    /**
     * listens for dialog close event. Opens snackbar if necessary
     * @param {MatDialogRef<any>} dialogRef
     * @private
     */
    EventDetailsComponent.prototype._handleModalClose = function (dialogRef) {
        var _this = this;
        var ERROR_MSG = 'An error has occurred, please try back later, or call 1-800-USA-AOPA if the error persists.';
        dialogRef.afterClosed().subscribe(function (success) {
            if (success === null) {
                return;
            }
            if (success) {
                _this.reloadEntity();
                _this.snackBar.open('Event Details', 'Updated', {
                    duration: 3000
                });
            }
            else {
                _this.snackBar.open(ERROR_MSG, 'Error', {
                    duration: 6000
                });
            }
        });
    };
    return EventDetailsComponent;
}());
export { EventDetailsComponent };
